(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-measure")) {
  customElements.define(
    "s-measure",
    class SectionMeasure extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.headings = [...this.querySelectorAll("h2[data-heading]")];
        this.menus = [...this.querySelectorAll(".js-measure__naviation-list")];
        this.triggers = [];

        this.renderMenus();
        this.addEventListeners();
        this.observeHeadings();
      }

      disconnectedCallback() {
        this.removeEventListeners();
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      addEventListeners() {
        this.triggers.forEach(trigger => {
          trigger.addEventListener("click", () => this.scrollTo(trigger.dataset.heading));
        });
      }

      removeEventListeners() {
        this.triggers.forEach(trigger => {
          trigger.removeEventListener("click", () => this.scrollTo(trigger.dataset.heading));
        });
      }

      scrollTo(heading) {
        const element = document.querySelector(`h2[data-heading="${heading}"]`);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          const offset = window.innerHeight / 4;

          window.scrollTo({
            top: elementPosition - offset,
            behavior: "smooth",
          });
        }
      }

      renderMenus() {
        const romanRegex = /^(?:M{0,3})(?:CM|CD|D?C{0,3})(?:XC|XL|L?X{0,3})(?:IX|IV|V?I{0,3})\.\s*/i;

        this.menus.forEach(menu => {
          const template = this.querySelector(".t-measure__naviation-item").innerHTML;
          menu.innerHTML = this.headings
            .map(heading => template.replaceAll("{id}", heading.dataset.heading).replaceAll("{title}", heading.innerText.replace(romanRegex, '').replace(':', '')))
            .join("");
        });
        
        // Reinitialize triggers after rendering menu
        this.triggers = [...this.querySelectorAll(".js-measure__naviation-item")];
      }

      observeHeadings() {
        const options = {
          root: null,
          rootMargin: "-40px",
          threshold: 0.5,
        };

        this.observer = new IntersectionObserver(entries => {
          let activeEntry = entries.find(entry => entry.isIntersecting);
          
          if (activeEntry) {
            const id = activeEntry.target.dataset.heading;
            this.triggers.forEach(item => {
              item.classList.toggle("is-active", item.dataset.heading === id);
            });
          }
        }, options);

        this.headings.forEach(heading => this.observer.observe(heading));
      }
    }
  );
}

},{}]},{},[1])

